import {fork, all} from 'redux-saga/effects';
import AccountRoot from './account';
import CompaniesRoot from './companies';
import ListsRoot from './lists';
import FoldersRoot from './folders';
import WorkspacesRoot from './workspaces';
import IntegrationsRoot from './integrations';
import TeamMembersRoot from './team_members';
import TemplatesRoot from './templates';
import PaymentsRoot from './payments';
import SalesCoachRoot from './sales_coach';
import DealsRoot from './deals';
import AnalyticsRoot from './analytics';
import SavedFiltersRoot from './saved_filters';
import SpecialServicesRoot from './special_services';

export default function* rootSaga(){
  yield all([
    fork(AccountRoot),
    fork(CompaniesRoot),
    fork(ListsRoot),
    fork(FoldersRoot),
    fork(WorkspacesRoot),
    fork(IntegrationsRoot),
    fork(TeamMembersRoot),
    fork(TemplatesRoot),
    fork(PaymentsRoot),
    fork(SalesCoachRoot),
    fork(DealsRoot),
    fork(AnalyticsRoot),
    fork(SavedFiltersRoot),
    fork(SpecialServicesRoot)
  ]);
}
